import axiosInstance from "../api/axiosInstance";

export const fetchPaymentHistory = () => axiosInstance.get("/payments/history");
